export default __webpack_public_path__ + "static/media/twitter-x-logo-png-white.e727d86c.png";